import { createSelector } from 'reselect';

import type Store from '~/types/Store';

import { StoreName, StoreStatusName } from '~/types/Store';

import { type ApplicationState } from '../store';

const getStoresStore = (state: ApplicationState) => state.stores;

const getStores = createSelector(getStoresStore, (storesStore) => Object.values(storesStore.data));

export const getStoresIsLoaded = createSelector(
  getStoresStore,
  (storesStore): boolean => storesStore.isLoaded,
);

export const getConnectedStores = createSelector(getStores, (stores) =>
  filterForConnectedStores(stores),
);

export const isWixConnected = createSelector(getConnectedStores, (stores) =>
  isStoreConnected(stores, StoreName.Wix),
);

export const isEBayConnected = createSelector(getConnectedStores, (stores) =>
  isStoreConnected(stores, StoreName.eBay),
);

const filterForConnectedStores = (stores: Store[]) =>
  stores.filter((store) => store?.status?.name === StoreStatusName.Connected);

const isStoreConnected = (connectedStores: Store[], storeName: string) =>
  !!connectedStores.find((store) => store?.storePlatform?.name === storeName);

export const hasStoreConnected = createSelector(
  getConnectedStores,
  (connectedStores) => connectedStores.length > 0,
);
